import { type DatabaseChangeType } from '@databases/types/redux';

import { getValueId } from '../../../../utils.ts';
import { type YJSChangeHandler } from '../../types.ts';

export const deleteField: YJSChangeHandler<DatabaseChangeType.DELETE_FIELD> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    db.deleteFields(change.fieldIds);

    change.fieldIds.forEach((fieldId) => {
      db.views.forEach((viewId: string) => {
        db.viewsById[viewId].removeFieldVisibilityField(fieldId, db.fields);
        db.viewsById[viewId].removeCalculation(fieldId);
        db.viewsById[viewId].sorts.deleteSortForFieldId(fieldId);
      });

      Object.keys(db.entriesById).forEach((entryId) => {
        db.entriesById[entryId].removeValue(fieldId);
      });

      // Remove all comments on the field
      db.entries.forEach((entryId) => {
        const valueId = getValueId(entryId, fieldId);

        if (valueId in db.commentThreads) {
          db.removeCommentsOnValue(valueId);
        }
      });
    });
  });
};
